"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckpointSchedule = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const internal_1 = require("../../../internal");
const types_1 = require("../../../types");
const conversion_1 = require("../../../utils/conversion");
const internal_2 = require("../../../utils/internal");
const notExistsMessage = 'Schedule no longer exists. It was either removed or it expired';
/**
 * Represents a Checkpoint Schedule for an Asset. Schedules can be set up to create Checkpoints at regular intervals
 */
class CheckpointSchedule extends internal_1.Entity {
    /**
     * @hidden
     */
    constructor(args, context) {
        const { pendingPoints } = args, identifiers = __rest(args, ["pendingPoints"]);
        super(identifiers, context);
        const { id, assetId } = identifiers;
        const sortedPoints = [...pendingPoints].sort((a, b) => a.getTime() - b.getTime());
        this.pendingPoints = sortedPoints;
        this.expiryDate = sortedPoints[sortedPoints.length - 1];
        this.id = id;
        this.asset = new internal_1.FungibleAsset({ assetId }, context);
    }
    /**
     * @hidden
     * Check if a value is of type {@link UniqueIdentifiers}
     */
    static isUniqueIdentifiers(identifier) {
        const { id, assetId } = identifier;
        return id instanceof bignumber_js_1.default && typeof assetId === 'string';
    }
    /**
     * Retrieve information specific to this Schedule
     */
    details() {
        return __awaiter(this, void 0, void 0, function* () {
            const { context: { polymeshApi: { query: { checkpoint }, }, }, id, context, asset, } = this;
            const rawId = (0, conversion_1.bigNumberToU64)(id, context);
            const scheduleOpt = yield checkpoint.scheduledCheckpoints((0, conversion_1.assetToMeshAssetId)(asset, context), rawId);
            if (scheduleOpt.isNone) {
                throw new internal_1.PolymeshError({
                    code: types_1.ErrorCode.DataUnavailable,
                    message: notExistsMessage,
                });
            }
            const schedule = scheduleOpt.unwrap();
            const points = [...schedule.pending].map(point => (0, conversion_1.momentToDate)(point));
            return {
                remainingCheckpoints: new bignumber_js_1.default(points.length),
                nextCheckpointDate: points[0],
            };
        });
    }
    /**
     * Retrieve all Checkpoints created by this Schedule
     */
    getCheckpoints() {
        return __awaiter(this, void 0, void 0, function* () {
            const { context: { polymeshApi: { query: { checkpoint }, }, }, context, asset: { id: assetId }, asset, id, } = this;
            const exists = yield this.exists();
            if (!exists) {
                throw new internal_1.PolymeshError({
                    code: types_1.ErrorCode.DataUnavailable,
                    message: notExistsMessage,
                });
            }
            const result = yield checkpoint.schedulePoints((0, conversion_1.assetToMeshAssetId)(asset, context), (0, conversion_1.bigNumberToU64)(id, context));
            return result.map(rawId => new internal_1.Checkpoint({ id: (0, conversion_1.u64ToBigNumber)(rawId), assetId }, context));
        });
    }
    /**
     * Determine whether this Checkpoint Schedule exists on chain
     */
    exists() {
        return __awaiter(this, void 0, void 0, function* () {
            const { context: { polymeshApi: { query: { checkpoint }, }, }, context, asset, id, } = this;
            const rawId = (0, conversion_1.bigNumberToU64)(id, context);
            const rawSchedule = yield checkpoint.scheduledCheckpoints((0, conversion_1.assetToMeshAssetId)(asset, context), rawId);
            return rawSchedule.isSome;
        });
    }
    /**
     * Return the Schedule's static data
     */
    toHuman() {
        const { asset, id, pendingPoints } = this;
        return (0, internal_2.toHumanReadable)({
            assetId: asset,
            id,
            pendingPoints,
            expiryDate: pendingPoints[pendingPoints.length - 1],
        });
    }
}
exports.CheckpointSchedule = CheckpointSchedule;
//# sourceMappingURL=index.js.map